const PaymentStatuses = Object.freeze({
  PENDING: 1,
  PAID: 2,
  FAILED: 3,
  CANCELED: 4,
});

export default PaymentStatuses;
